import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './Home';
import Rsvp from './Rsvp';
import Confirmation from './Confirmation';

function App() {
  const partyDetails = {
    childsName: "Advait",
    age: "5",
    date: "Saturday, September 19, 2026",
    time: "2:00 PM - 4:00 PM",
    locationName: "Pump It Up of Santa Clara",
    locationAddress: "2919 Mead Ave, Santa Clara, CA 95051",
    locationPhone: "408-713-1200",
    rsvpDate: "September 14th",
    rsvpContact: "mom-or-dad@email.com",
    // For the "add to calendar" link (local time, America/Los_Angeles).
    calendarStart: "20260919T140000",
    calendarEnd: "20260919T160000"
  };

  return (
    // BrowserRouter must be the top-level component
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home partyDetails={partyDetails} />} />
          <Route path="/rsvp" element={<Rsvp partyDetails={partyDetails} />} />
          <Route path="/rsvp/confirmed" element={<Confirmation partyDetails={partyDetails} />} />
        </Routes>
        <footer>
          <p>Can't wait to bounce with you!</p>
        </footer>
      </div>
    </BrowserRouter>
  );
}

export default App;
